import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

import store from '@/store'
import { userLinks } from './user'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/login',
    name: 'login',
    component: () =>
      import(/* webpackChunkName: "login" */ '../views/LoginPage.vue'),
  },
  ...userLinks,
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to,from) => {
  if (store.getters.role && to.meta.role){
    if (!to.meta.role.includes(store.getters.role)){
      return { name: from ? from.name : 'home' }
    }
  }
  
})


export default router
